import { RootState } from 'app/store';

export const selectLoading = (state: RootState) => state.profile.loading;

export const selectPasswordResetSuccess = (state: RootState) =>
  state.profile.passwordResetSuccess;

export const selectPasswordResetError = (state: RootState) =>
  state.profile.passwordResetError;

export const selectUpdateProfileDataSuccess = (state: RootState) =>
  state.profile.updateProfileDataSuccess;

export const selectUpdateProfileDataError = (state: RootState) =>
  state.profile.updateProfileDataError;
